<template>
  <div class="has-background-white custom-fields-card p-4">
    <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
    <div class="has-background-grey-lighter is-border-radius-sm">
      <div class="column">
        <div class="columns">
          <div class="column is-8 is-6-desktop has-text-dark line-height is-flex is-align-items-center is-size-3">
          <span> Custom Fields ({{ `${$_.get(existingCustomFields, 'fields.length', 0)}` }}/10)</span>
          <div class="is-divider-vertical mt-0"></div>
          <span class="has-text-weight-semibold mr-2">MySQL Table</span>
          <span>{{ getSQLTableName }}</span>
          </div>
            <div class="column is-flex is-justify-content-flex-end is-align-items-center">
              <mf-multi-select
              :modelValue="selectedCustomOptions"
              :options="customOptions"
              track-by="value"
              label="label"
              :multiple="false"
              placeholder="Add Custom Field"
              :close-on-select="true"
              @update:modelValue="openFieldModal($event, true)"
              :disabled="existingCustomFields?.fields?.length >= 10 || disabledOnPermission"
            ></mf-multi-select>
            <div class="is-divider-vertical mt-0"></div>
            <div class="buttons">
              <button class="button is-dark is-rounded" @click="save()" :disabled="disableAction() || disabledOnPermission">Apply Updates</button>
              <button class="button is-outlined is-rounded" @click="discard()" :disabled="disableAction() || disabledOnPermission">Discard Updates</button>
              <div class="is-divider-vertical mt-0"></div>
              <button class="button p-0 has-text-black-bis" @click="openActivityHistory">
                <i class="icon-activityhistory" ></i>
              </button>
              <div class="is-divider-vertical mt-0 ml-0"></div>
                <button class="button has-background-black-bis has-text-white p-0 button-info" @click="isInfoActive = !isInfoActive">
                  <span class="is-size-3 has-text-dark">i</span>
                </button>
            </div>
            
            </div>
        </div>
          <draggable
            v-if="!$_.isEmpty(existingCustomFields?.fields)"
            v-model="existingCustomFields.fields"
            item-key="_id"
            tag="div"
            class="columns is-multiline no-select"
            :animation="150"
            :ghost-class="'is-drag-ghost'"
            :chosen-class="'is-drag-chosen'"
            :drag-class="'is-drag-dragging'"
            :disabled="disabledOnPermission"
            :filter="'.no-drag'"
            :force-fallback="true"
            :move="() => { isRearranged = true; return true; }"
          >
            <template #item="{ element: cf }">
              <div class="column is-3">
                <div class="card" :class="cf.archived?.value ? 'archived-border': cf.isNew || cf.isEdited ? 'updated-border': 'normal-border'">
                  <header class="card-header">
                    <h3
                        class="has-text-weight-bold is-size-3 is-flex is-justify-content-space-between is-align-items-center card-header-title"
                        >
                      <span class="has-text-dark" :class="cf.archived?.value ? 'has-text-danger': cf.isNew || cf.isEdited ? 'has-text-info': 'has-text-black-bis'">{{ cf.__t === 'String' ? 'Text' : cf.__t }}</span>
                      <div class="is-flex">
                        <div class="is-flex" v-if="!cf.archived?.value">
                          <button class="button p-0 no-drag has-text-black-bis" :disabled="disabledOnPermission" @click="openFieldModal(cf)">
                            <i class="icon-edit is-clickable"></i>
                          </button>
                          <div class="is-divider-vertical mt-0 "></div>
                          <button class="button p-0 no-drag  has-text-black-bis" :disabled="disabledOnPermission" @click="archiveCustomField(cf)">
                            <i class="icon-removedelete is-clickable"></i>
                          </button>
                        </div>
                        <button v-else class="button p-0 no-drag  has-text-black-bis" @click="restoreCustomField(cf)">
                            <i class="icon-cf-reset is-clickable"></i>
                        </button>                    
                      </div>
                    </h3>
                  </header>
                  <div class="card-content align-items-center">
                    <div class="content">
                      <h3 class="has-text-black-bis has-text-weight-semibold is-size-3 mb-1">{{ cf.label }}</h3>
                      <div v-if="cf.__t === 'Dropdown'" class="mt-2">
                          <mf-multi-select
                            :options="cf.options"
                            track-by="_id"
                            label="displayValue"
                            :placeholder="cf.placeholder"
                            :multiple="false"
                          />
                      </div>

                      <div v-if="['String', 'Number'].includes(cf.__t)">
                        <input class="input mt-2" :placeholder="cf.placeholder" :disabled="!isEditable"/>
                        <h3 v-if="cf.__t === 'String'" class="has-text-black-bis mb-1 mt-3 is-size-5">
                        <span class="has-text-weight-semibold mr-2">Enforced Uniqueness</span> 
                        <span class="has-text-weight-normal">{{ cf.uniqueAcross }}</span>
                        </h3>
                      </div>

                      <div v-if="cf.__t === 'Date'" class="mt-2">
                        <mf-date
                          :is-edit="true"
                          :input-props="{}"
                          :placeholder='"mm/dd/yyyy"'
                          disabled
                        />
                      </div>

                      <div v-if="cf.__t === 'Checkbox'">
                        <o-checkbox v-model="isChecked" disabled>
                        </o-checkbox>
                      </div> 
                    </div>
                  </div>
                  <footer class="card-footer is-size-5">
                    <span class="has-text-weight-semibold has-text-black-bis mr-2">MySQL Column</span> <span class="has-text-black-bis">{{ sqlColumnName(cf) }}</span>
                  </footer>
                </div>
              </div>
            </template>
          </draggable> 
      </div>
    </div>
  </div>
  <custom-fields-modal
    v-if="isModalActive"
    :is-active="isModalActive"
    @close="(val) => { val ? dataBeforeEdit = val : null; isModalActive = false; selectedCustomOptions = null }"
    @add-custom-field="addCustomFields"
    :customField="customFieldValue"
    :modificationType="modificationType"
    :tabType="tabType()"
    :dataBeforeEdit="dataBeforeEdit"
  ></custom-fields-modal>
  <activity-slider
    :isActive="isActive"
    :id="$store.state.userData.company"
    :type="tabType()"
    @update:isActive="isActive=false">
  </activity-slider>
  <o-modal :active="isInfoActive" class="modal-sm" :closeOnEscape="true">
    <div class="modal-card">
      <header class="modal-card-head is-borderless">
        <p class="card-header-title is-justify-content-left has-text-black-bis">
          Custom Fields Information
        </p>
        <div class="is-divider-vertical"></div>
        <i class="icon-close is-clickable" @click="isInfoActive = false"></i>
      </header>
      <section class="modal-card-body line-height has-text-black-bis no-validate">
				<ul class="mb-3">
					<li class="ml-5 is-italic">
						You can add up to 10 custom fields to {{ getCFLabelType}}. All Custom Fields Updates (Additions, edits and deletions) will be applied to all existing and newly created {{ getCFLabelType }}.
					</li>
					<li class="ml-5 is-italic">
            Custom Fields will be displayed in the order shown below. To change the display order of Custom Fields: Select and hold the Custom Field you want to move, drag the Custom Field to the desired position and release.
          </li>
				</ul>

      </section>
      <footer class="modal-card-foot"></footer>
    </div>
  </o-modal>
</template>

<script>

import { reactive, toRefs, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { cloneDeep, isEmpty, isString, lowerCase, some, update } from 'lodash';
import draggable from 'vuedraggable';
import CustomFields from '../models/CustomFields';
import CustomFieldsModal from './modals/CustomFieldsModal.vue';
import MfDate from '@/components/abstract/MfDate.vue';
import { DialogProgrammatic } from '@/components/Dialog';
import ActivitySlider from '@/components/ActivitySlider.vue';
import PermissionMixin from './mixins/PermissionMixin';
import { screenLabelMap } from '@/components/mixins/UtilityMixin';

export default {
  name: 'CustomFields',
  props: {},
  components: {
    CustomFieldsModal,
    MfDate,
    draggable,
    ActivitySlider,
  },
  setup() {
    const store = useStore();
    const { getPermissionValues } = PermissionMixin();
    const customOptions = [
      { label: 'Checkbox', value: 'checkbox' },
      { label: 'Date', value: 'date' },
      { label: 'Dropdown Menu', value: 'dropdown' },
      { label: 'Number', value: 'number' },
      { label: 'Text', value: 'string' },
    ]

    const state = reactive({
      selectedCustomOptions: null,
      isModalActive: false,
      showDateModal: false,
      modificationType: '',
      existingCustomFields: {},
      isChecked: false,
      dataBeforeEdit: null,
      editMode: false,
      updatedCustomFields: [],
      isRearranged: false,
      isLoading: false,
      isActive: false,
      isInfoActive: false,
    });
    
    const tabType = () => {
      return screenLabelMap[store.state.activeScreen]?.tab || '';
    };

    const getCFLabelType = computed(() => {
      return screenLabelMap[store.state.activeScreen]?.label || '';
    });

    const getSQLTableName = computed(() => {
      return screenLabelMap[store.state.activeScreen]?.table || '';
    });

    const openFieldModal = (newValue, isCreate = false) => {
      state.selectedCustomOptions = isString(newValue) ? lowerCase(newValue) : newValue;
      if (isEmpty(state.selectedCustomOptions) && isEmpty(state.selectedCustomOptions.value)) return;
      isCreate ? state.modificationType = 'create' : state.modificationType = 'edit';
      state.isModalActive = true;
    };

    const addCustomFields = async (payload) => {
      try {
        state.isLoading = true;
        state.editMode = true;
        isEmpty(payload.oldCfs) ? state.dataBeforeEdit = null : state.dataBeforeEdit = payload.oldCfs;
        if (payload.newCfs._id) {
          if (payload.newCfs.isNew || payload.newCfs.isEdited) {
            const index = state.updatedCustomFields.findIndex((cf) => cf._id === payload.newCfs._id);
            if (index !== -1) {
              state.updatedCustomFields[index] = payload.newCfs;
            } else {
              state.updatedCustomFields.push({ ...payload.newCfs });
            }
          }
          const existingIndex = state.existingCustomFields.fields.findIndex((cf) => cf._id === payload.newCfs._id);
          if (existingIndex !== -1) {
            state.existingCustomFields.fields[existingIndex] = { ...payload.newCfs };
          }
        } else {
          payload.newCfs._id = `new-${Date.now()}`;
          if (isEmpty(state.existingCustomFields)) {
            state.existingCustomFields = { fields: [{ ...payload.newCfs }] };
          } else {
            state.existingCustomFields.fields.push({ ...payload.newCfs });
          }
          state.updatedCustomFields.push({ ...payload.newCfs });
        }
      } catch (error) {
        console.error('Error adding custom fields:', error);
      } finally {
        state.isLoading = false;
      }
    };

    const customFieldValue = computed(() => {
      const selected = state.selectedCustomOptions;
      if (isEmpty(selected)) return '';
      return isEmpty(selected.value) ? selected : selected.value;
    });

    const sqlColumnName = (cf) => {
      if (isEmpty(state.existingCustomFields?.tableMapper)) return '';
      for (const [key , value] of Object.entries(state.existingCustomFields?.tableMapper)) {
        if (value && value === cf._id) return key;
      };
    }
    onBeforeMount(async () => {
      try {
        state.isLoading = true;
        state.existingCustomFields = await CustomFields.getCustomFields({ type: tabType(), initialLoad: true });
        state.dataBeforeEdit = state.existingCustomFields;
      } catch (error) {
        console.error('Error fetching custom fields:', error);
      } finally {
        state.isLoading = false;
      }
    });

    const archiveCustomField = async (cf) => {
      await DialogProgrammatic.confirm({
        title: 'Mark Custom Field For Deletion',
        message: "<span class='has-text-danger'> Note that this Custom Field will not be fully deleted until all Cutsom Fields updates are applied. Once applied, all deleted Custom Fields will be removed from all existing orders and related MySQL tables. </span>",
        beforeMessage: `Are you sure you want to mark the custom field "${cf.label}" for deletion?`,
        okButton: 'Mark For Deletion',
        cancelButton: 'Cancel',
        onConfirm: async () => {
          state.isLoading = true;
          if (!cf.archived) cf.archived = { value: true };
          else cf.archived.value = true;
          const index = state.updatedCustomFields.findIndex((field) => field._id === cf._id);
          if (index !== -1) {
            state.updatedCustomFields[index] = cf;
          } else {
            state.updatedCustomFields.push(cf);
          }
          state.isLoading = false;
        },
      });
    };

    const save = async () => {
      try {
        await DialogProgrammatic.confirm({
          title: 'Apply Custom Field Updates',
          message: "<span class='has-text-danger'> Note that all Custom Field marked for deletion will be removed from all existing order and related MySQL tables.</span>",
          beforeMessage: `All Custom Field updates will be applied to all existing and newly created ${getCFLabelType.value}. This process may take some time based on the number of existing orders. Updates cannot be reverted once they are applied.`,
          okButton: 'Apply Updates',
          cancelButton: 'Back',
          onConfirm: async () => {
            state.isLoading = true;
            state.updatedCustomFields = state.updatedCustomFields.filter((cf) => {
              if (!isEmpty(cf.isNew)) return !cf?.archived?.value;
              return cf;
            }).map((cf) => {
              if (cf?._id?.startsWith('new-')) delete cf._id;
              if (!isEmpty(cf.isNew)) delete cf.isNew;
              if (!isEmpty(cf.isEdited)) delete cf.isEdited;
              return cf;
            });
            if (!isEmpty(state.updatedCustomFields) || state.isRearranged) {
              if (state.isRearranged) {
                if (!isEmpty(state.updatedCustomFields)) {
                  state.updatedCustomFields.forEach((cf, index) => {
                    const existingIndex = state.existingCustomFields.fields.findIndex((field) => field._id === cf._id);
                    if (existingIndex !== -1) {
                      state.existingCustomFields.fields[existingIndex] = cf;
                    }
                  });
                }
                state.existingCustomFields.fields.map((cf, index) => {
                  cf.displayOrder = index;
                  if (cf?._id?.startsWith('new-')) delete cf._id;
                  if (!isEmpty(cf.isNew)) delete cf.isNew;
                  if (!isEmpty(cf.isEdited)) delete cf.isEdited;
                  return cf;
                })
              }
              let paramsObj = {
                type: tabType(),
                fields: state.isRearranged ? state.existingCustomFields.fields : state.updatedCustomFields,
              };
              await CustomFields.updateCustomField(paramsObj);
              state.updatedCustomFields = [];
            }
            state.existingCustomFields = await CustomFields.getCustomFields({type: tabType()});
            state.dataBeforeEdit = cloneDeep(state.existingCustomFields);
            state.editMode = false;
            state.isRearranged = false;
            state.isLoading = false;
          },
        });
      } catch (error) {
        console.error('Error saving custom fields:', error);
      }
    };

    const discard = async () => {
      await DialogProgrammatic.confirm({
        title: 'Discard All Custom Field Updates',
        message: 'Discarding current Custom Field updates will reset all Custom Fields to the last updated versions',
        okButton: 'Discard Updates',
        cancelButton: 'Cancel',
        onConfirm: async () => {
          state.isLoading = true;
          state.existingCustomFields = await CustomFields.getCustomFields({type: tabType()});
          state.updatedCustomFields = [];
          state.editMode = false;
          state.isRearranged = false;
          state.isLoading = false;
        },
      });
    };

    const restoreCustomField = async (cf) => {
      await DialogProgrammatic.confirm({
        title: 'Restore Custom Field',
        message: 'Custom Field cannot be restored after Custom Field updates have been applied.',
        beforeMessage: 'Restore Custom Field to the last saved state',
        okButton: 'Restore Custom Field',
        cancelButton: 'Cancel',
        onConfirm: async () => {
          state.isLoading = true;
          if (!cf.archived) cf.archived = { value: false };
          else cf.archived.value = false;
          if (cf._id) {
            const existingIndex = state.updatedCustomFields.findIndex((field) => field._id === cf._id);
            if (existingIndex !== -1) {
              state.updatedCustomFields.splice(existingIndex, 1);
            }
          }
          state.isLoading = false;
        },
      });
    };

    const disableAction = () => {
      if (state.editMode || (!isEmpty(state.existingCustomFields) && some(state.existingCustomFields?.fields, (field) => field?.archived && field.archived?.value)) || state.isRearranged) return false;
      return true;
    };

    const openActivityHistory = () => {
      state.isActive = true;
    };

    const disabledOnPermission = computed(() => {
      const params = {
        permissionModule: 'app&projects',
        type: 'custom_fields',
      }
      return getPermissionValues(params)
    });

    return {
      ...toRefs(state),
      customOptions,
      openFieldModal,
      addCustomFields,
      customFieldValue,
      archiveCustomField,
      tabType,
      save,
      discard,
      restoreCustomField,
      disableAction,
      sqlColumnName,
      openActivityHistory,
      disabledOnPermission,
      getCFLabelType,
      getSQLTableName,
    };
  },
};
</script>

<style scoped>
.is-drag-ghost {
  opacity: 0.4;
}
.is-drag-chosen {
  cursor: grabbing;
}

.button-info {
    height: 20px !important;
    width: 20px !important;
    border: 1px solid #999 !important;
    background-color: #e2e5e7 !important;
    margin-top: 2px;
    color: #000;
    i, i::before {
      font-size: 16px !important;
      color: #000;
    }
    &:hover span, &:hover i::before {
      color: #fff !important;
    }
    &:hover {
      border-color: #fe8137 !important;
    }
  }

  i.icon-close {
		display: inline !important;
	}
	ul {
		list-style: disc !important;
	}
	.circle-list {
		list-style: circle !important;
	}
	header,
	footer {
		background-color: #fff;
	}
	.modal-card-foot {
		height: 16px !important;
	}
	::v-deep(.o-modal__close) {
		display: none !important;
	}
	::v-deep(.o-modal__overlay) {
		opacity: 0.5;
	}
</style>